export function convertToCST(date) {
  // Get UTC time in milliseconds
  const utcTime = date.getTime() + (date.getTimezoneOffset() * 60000);
// CST is UTC-6:00
  const cstOffset = -6 * 60 * 60 * 1000; // Offset in milliseconds
  // Convert UTC time to CST
  const cstTime = new Date(utcTime + cstOffset);
  return cstTime;
}